<template>
  <div class="visit-page mt-5 mb-5">
    <div class="container container--out-pad container--add-pad">
      <!-- title -->
      <div class="row">
        <div class="col-xl-12">
          <h1 class="page-title">ОФОРМЛЕНИЕ ЗАЯВКИ</h1>
        </div>
      </div>
      <!-- /title -->
    </div>
    <div class="container container--out-pad container--add-pad">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 order-clg-2">
          <div class="visit__request-item">
            Поездка
            <div class="visit__request-item-required">*</div>
          </div>
          <div class="visit__request-item-title">
            {{ visit.title }}
          </div>
          <ValidationObserver slim v-slot="{ invalid, handleSubmit }">
            <form @submit.prevent="handleSubmit(postRequest)">
              <div class="visit__request-form">
                <div class="visit__request-item">
                  Дата поездки
                  <div class="visit__request-item-required">*</div>
                </div>
                <ValidationProvider :name="visit_at" rules="required">
                  <input
                      placeholder="Выберите дату"
                      v-model="visit_at"
                      class="form-control date"
                      type="text"
                      id="date"
                      autocomplete="off"
                      readonly
                      @blur="getDate"
                      style="background-color: #fff"
                  />
                </ValidationProvider>
              </div>
              <div class="visit__request-item-desc">
                Информация о кураторе группы со стороны заказчика
              </div>
              <div class="visit__request-form">
                <div class="visit__request-item">
                  ФИО куратора
                  <div class="visit__request-item-required">*</div>
                </div>
                <ValidationProvider
                    :name="curator_name"
                    rules="required"
                    v-slot="{ errors }"
                >
                  <input
                      v-model="curator_name"
                      class="form-control"
                      type="text"
                      maxlength="35"
                  />
                  <span class="error-message" v-if="errors[0]">
                    <br />
                    **{{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="visit__request-form">
                <div class="visit__request-item">
                  Номер телефона куратора
                  <div class="visit__request-item-required">*</div>
                </div>
                <ValidationProvider
                    :name="curator_phone"
                    rules="phone: 18"
                    v-slot="{ errors }"
                >
                  <input
                      v-model="curator_phone"
                      v-mask="'+7-(###)-###-##-##'"
                      class="form-control"
                      type="text"
                  />
                  <span class="error-message" v-if="errors[0]">
                    <br />
                    **{{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="visit__request-form">
                <div class="visit__request-item">
                  E-mail куратора
                  <div class="visit__request-item-required">*</div>
                </div>
                <ValidationProvider
                    :name="curator_email"
                    rules="email"
                    v-slot="{ errors }"
                >
                  <input
                      v-model="curator_email"
                      class="form-control"
                      type="text"
                  />
                  <span class="error-message" v-if="errors[0]">
                    <br />
                    **{{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="visit__request-form">
                <div class="visit__request-item">
                  Количество участников
                  <div class="visit__request-item-required">*</div>
                </div>
                <div class="visit__request-people">
                  <div
                      class="visit__request-people-count"
                      @click="decrementUserCountHandle"
                  >
                    -
                  </div>
                  <div>
                    <input
                        class="visit__request-people-count"
                        v-model="user_count"
                        readonly
                    />
                  </div>
                  <div
                      class="visit__request-people-count"
                      @click="incrementUserCountHandle"
                  >
                    +
                  </div>
                </div>
                <transition name="fade">
                  <div class="visit__request-people-count-desc">
                    Минимальное количество для организации поездки - 5 человек
                    Максимальное количество – 20 человек. Если часть мест
                    забронировано, то доступное к заказу количество мест на
                    выбранную дату указывается в календаре.
                  </div>
                </transition>
              </div>
              <div class="visit-detail__block-list-description">
                Необходимо предоставить следующие закрывающие документы для
                подтверждения затрат и&nbsp;списания маркетингового ретро
                бонуса:
              </div>
              <ul class="visit-detail__block-list">
                <li>ЖД&nbsp;и&nbsp;авиа билеты</li>
                <li>Ваучер из&nbsp;гостиницы, счет и&nbsp;ПП об&nbsp;оплате</li>
                <li>
                  Акт выполненных работ от&nbsp;подрядчика, выполняющего услуги
                  по&nbsp;трансферу
                </li>
                <li>
                  Акт выполненных работ от&nbsp;подрядчика, выполняющего услуги
                  по&nbsp;организации фотосессии и/или экскурсии, если данные
                  услуги вошли в&nbsp;программу
                </li>
                <li>Фотоотчет, не&nbsp;менее 5&nbsp;фото</li>
              </ul>
              <div class="visit-detail__block-list-description-bold">
                Более подробно с процессом организации поездки можно
                ознакомиться
                <a class="visit__link" href="/how-to-order"> здесь </a>
              </div>
              <div class="visit__request-sum">
                <div class="visit__button">
                  <button
                      :class="
                                          invalid || !curator_email || disabled || !isConsentApproved
                                            ? 'visit__button-btn disabled'
                                            : 'visit__button-btn'
                                        "
                      type="submit"
                      :disabled="invalid || !curator_email || disabled || !isConsentApproved"
                  >
                    ОФОРМИТЬ ЗАЯВКУ
                  </button>
                  <label class="consent-checkbox-label">
                                      <span class="consent-checkbox-input-wrapper">
                                        <input
                                            class="consent-checkbox"
                                            type="checkbox"
                                            name="consent"
                                            :checked="isConsentApproved"
                                            @change="(e) => onConsentChange(e)"
                                        />
                                      </span>
                    <span class="consent-checkbox-text">Согласен с условиями <a :href="consentLink" target="_blank">Политики в отношении обработки персональных данных</a></span>
                  </label>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 order-clg-1">
          <div class="visit-detail__block" style="margin-top: 0">
            <div class="visit-detail__block-title">
              Средняя стоимость посещения
            </div>
            <div class="visit-detail__block-list-title">
              Базовая стоимость поездки
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">Размер группы</div>
              <div class="visit-detail__block-table-item">
                Стоимость экскурсии (включая НДС), руб.
              </div>
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">5 человек</div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'perm'"
              >
                225 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'torzhok'"
              >
                150 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'kazakhstan'"
              >
                470 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'tyumen'"
              >
                250 000
              </div>
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">до 10 человек</div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'perm'"
              >
                305 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'torzhok'"
              >
                220 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'kazakhstan'"
              >
                770 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'tyumen'"
              >
                450 000
              </div>
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">
                от 10 до 15 человек
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'perm'"
              >
                410 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'torzhok'"
              >
                300 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'kazakhstan'"
              >
                1 120 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'tyumen'"
              >
                620 000
              </div>
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">
                от 15 до 20 человек
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'perm'"
              >
                500 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'torzhok'"
              >
                370 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'kazakhstan'"
              >
                1 470 000
              </div>
              <div
                  class="visit-detail__block-table-item"
                  style="justify-content: center"
                  v-if="visit.url === 'tyumen'"
              >
                850 000
              </div>
            </div>
          </div>
          <div class="visit-detail__block-table-description">
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M10 5C9.73479 5 9.48043 5.10536 9.2929 5.29289C9.10536 5.48043 9 5.73478 9 6V10C9 10.2652 9.10536 10.5196 9.2929 10.7071C9.48043 10.8946 9.73479 11 10 11C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5ZM10.92 13.62C10.8981 13.5563 10.8679 13.4957 10.83 13.44L10.71 13.29C10.5694 13.1512 10.3908 13.0572 10.1968 13.0199C10.0028 12.9825 9.80212 13.0034 9.62 13.08C9.49882 13.1306 9.38721 13.2017 9.29 13.29C9.19732 13.3834 9.124 13.4943 9.07423 13.6161C9.02447 13.7379 8.99924 13.8684 9 14C9.00159 14.1307 9.02876 14.2598 9.08 14.38C9.12492 14.5041 9.19657 14.6168 9.28989 14.7101C9.38321 14.8034 9.49591 14.8751 9.62 14.92C9.73971 14.9729 9.86913 15.0002 10 15.0002C10.1309 15.0002 10.2603 14.9729 10.38 14.92C10.5041 14.8751 10.6168 14.8034 10.7101 14.7101C10.8034 14.6168 10.8751 14.5041 10.92 14.38C10.9712 14.2598 10.9984 14.1307 11 14C11.0049 13.9334 11.0049 13.8666 11 13.8C10.9828 13.7362 10.9558 13.6755 10.92 13.62ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                  fill="#D2233C"
              />
            </svg>
            Организацией поездки дилер занимается самостоятельно.
          </div>
          <div class="visit-detail__block">
            <div class="visit-detail__block-list-title">Компенсация затрат</div>
            <div class="visit-detail__block-list-description">
              Стоимость экскурсии будет компенсирована ООО
              <br />&laquo;ЛЛК-Интернешнл&raquo; (не&nbsp;более суммы указанной
              в&nbsp;таблице компенсаций) за&nbsp;счет списания маркетингового
              ретро бонуса при предоставлении подтверждающих документов.
            </div>
            <div class="visit-detail__block-list-description">
              В&nbsp;случае, если на&nbsp;балансе дилера недостаточно суммы
              ретро бонуса, поездку возможно организовать за&nbsp;свой счет, без
              списания баллов.
            </div>
          </div>
          <div class="visit-detail__block">
            <div class="visit-detail__block-list-title">
              Компенсации подлежат такие расходы
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" />
              <div class="visit-detail__block-list-description-items">
                Авиа/жд билеты (МСК-место назначения-МСК)
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" />
              <div class="visit-detail__block-list-description-items">
                Проживание
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" />
              <div class="visit-detail__block-list-description-items">
                Трансфер из/в аэропорт
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" />
              <div class="visit-detail__block-list-description-items">
                Обед на производстве
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" />
              <div class="visit-detail__block-list-description-items">Ужин</div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" />
              <div class="visit-detail__block-list-description-items">
                Экскурсионные услуги
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" />
              <div class="visit-detail__block-list-description-items">
                Фотосъемка профессионального фотографа
              </div>
              <div class="visit-detail__block-list-description-text">
                <span style="color: red">***</span>
                В&nbsp;случае, если дилер добирается из&nbsp;соседнего региона,
                может быть компенсирована стоимость трансфера (при наличии
                подтверждающих документов)
              </div>
            </div>
          </div>
          <div class="visit-detail__block">
            <div class="visit-detail__description-last">
              <div class="visit-detail__block-list-title">
                При бронировании даты и&nbsp;времени экскурсии, необходимо
                приобретать
              </div>
              <ul class="visit-detail__block-list">
                <li>Возвратные авиа/жд билеты</li>
                <li>Бронь гостиниц без штрафных санкций</li>
              </ul>
              <div class="visit-detail__block-table-description">
                <DangerIcon />
                Экскурсия может быть отменена в связи с форс-мажором.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, post } from "@/lib/axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { Datepicker } from "vanillajs-datepicker";
import DangerIcon from "../../../components/visit/DangerIcon.vue";
import ru from "vanillajs-datepicker/js/i18n/locales/ru.js";
import { mapGetters } from "vuex";
import { showMessage } from "@/lib/toasted";

export default {
  name: "VisitRequestForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    DangerIcon,
  },
  data: () => ({
    datePicker: null,
    user_count: 5,
    visit_at: "",
    curator_name: "",
    curator_phone: "",
    curator_email: "",
    city: "",
    course_id: "",
    format_id: "",
    visit: "",
    current_count: 20,
    disabled: false,
    availableDates: [],
    isConsentApproved: false,
  }),
  computed: {
    ...mapGetters('common', [ 'consentLink' ]),
  },
  methods: {
    onConsentChange(e) {
      this.isConsentApproved = e.target.checked;
    },
    availableDateClickHandle(event) {
      const date = event.target.getAttribute("data-date");
      const formattedDate = Datepicker.formatDate(
          new Date(Number(date)),
          "yyyy-mm-dd"
      );
      const free_seats = this.visit.visitDates.find(
          (visitDate) => visitDate.visit_at === formattedDate
      )?.free_seats;
      const tooltipMessage =
          free_seats < 5
              ? `Количество мест меньше 5-ти`
              : `Доступно ${free_seats} мест`;
      this.current_count = free_seats < 5 ? 5 : free_seats;
      event.target.setAttribute("data-tooltip-visit", tooltipMessage);
    },
    updateDateHandlers() {
      this.availableDates.forEach((availableDate) => {
        availableDate.removeEventListener(
            "click",
            this.availableDateClickHandle
        );
        availableDate.removeAttribute("data-tooltip-visit");
      });
      this.availableDates = Array.from(
          this.datePicker.picker.main.getElementsByClassName("datepicker-cell")
      ).filter((date) => !date.classList.contains("disabled"));
      this.availableDates.forEach((availableDate) => {
        availableDate.addEventListener("click", this.availableDateClickHandle);
      });
    },
    createDatePicker() {
      const date = document.getElementById("date");
      Object.assign(Datepicker.locales, ru);
      const mappedDateVisits = this.visit.visitDates
          .filter((visitDate) => !!visitDate.free_seats)
          .map((visitDate) => visitDate.visit_at);

      const datePickerParams = {
        format: "dd/mm/yyyy",
        defaultViewDate: new Date(),
        minDate: new Date(),
        maxDate: new Date().setFullYear(new Date().getFullYear() + 1),
        language: "ru",
        datesDisabled: (date) => {
          return !mappedDateVisits.includes(
              Datepicker.formatDate(date, "yyyy-mm-dd")
          );
        },
      };
      this.datePicker = new Datepicker(date, datePickerParams);
      this.datePicker.picker.controls.nextButton.addEventListener(
          "click",
          this.updateDateHandlers
      );
      this.datePicker.picker.controls.prevButton.addEventListener(
          "click",
          this.updateDateHandlers
      );
      this.datePicker.element.addEventListener(
          "changeMonth",
          this.updateDateHandlers
      );
      this.updateDateHandlers();
    },
    incrementUserCountHandle() {
      if (this.user_count !== this.current_count) {
        this.user_count += 1;
      }
    },
    decrementUserCountHandle() {
      if (this.user_count !== 5) {
        this.user_count -= 1;
      }
    },
    getDate() {
      if (this.datePicker) {
        this.visit_at = Datepicker.formatDate(
            new Date(this.datePicker.dates[0]),
            "dd/mm/yyyy"
        );
      }
    },
    async fetchData() {
      await get(`visit/all/${this.$route.params.slug}`).then((response) => {
        this.visit = response.data;
      });
    },
    async postRequest() {
      const { curator_name, curator_phone, curator_email, user_count } = this;
      const current_date = Datepicker.formatDate(
          new Date(this.datePicker.dates[0]),
          "yyyy/mm/dd"
      );
      let ttpType = 0;
      switch (this.visit.url) {
        case "perm":
          ttpType = 1;
          break;
        case "torzhok":
          ttpType = 2;
          break;
        case "kazakhstan":
          ttpType = 3;
          break;
        case "tyumen":
          ttpType = 4;
          break;
        case "test":
          ttpType = 5;
          break;
      }
      const visit_id = this.visit.id;
      if (!this.disabled) {
        this.disabled = true;
        await post("visit-order/create-order", {
          visit_id: visit_id,
          visit_at: current_date,
          curator_name: curator_name,
          curator_email: curator_email,
          curator_phone: curator_phone,
          user_count: user_count,
          tpp_type: ttpType,
          consent: this.isConsentApproved,
        })
            .then((response) => {
              if (response.data && response.data.status === "error") {
                showMessage(response.data.status, response.data?.message);
                this.disabled = false;
              } else {
                this.$router.replace({ name: "SuccessfulVisit" });
              }
            })
            .catch((e) => {
              console.log(e);
            });
        this.disabled = false;
        this.isConsentApproved = false;
      }
    },
  },
  async mounted() {
    await this.fetchData();
    this.createDatePicker(this.visit.id);
  },
  metaInfo() {
    return {
      title: this.visit.title + ` - ЛУКМАРКЕТ`,
    };
  },
};
/* eslint-disable */
</script>

<style lang="sass">

[data-tooltip-visit]
  position: relative

[data-tooltip-visit]::before
  content: attr(data-tooltip-visit)
  position: absolute
  width: 130px
  height: 33px
  font-size: 12px
  line-height: 12px
  left: 0
  bottom: 35px
  background: #F7F7F9
  color: #000000
  padding: 10px
  pointer-events: none
  opacity: 0
  transition: 0.3s ease-in-out
[data-tooltip-visit]:hover::after
  content: " "
  position: absolute
  bottom: 110%
  left: 50%
  margin-left: -5px
  width: 12px
  height: 12px
  border-top: 10px solid #F7F7F9
  border-right: 6px solid transparent
  border-left: 6px solid transparent
  font-size: 0
  line-height: 0


[data-tooltip-visit]:hover::before
  opacity: 1
  bottom: 50px

.error-message
  color: #D2233C

.fade-enter-active, .fade-leave-active
  transition: opacity .3s

.fade-enter, .fade-leave-to
  opacity: 0


.visit__request
  &-title
    font-size: 24px
    line-height: 25px
    text-transform: uppercase
    font-weight: 700
    padding: 60px 0 20px 0

  &-price
    font-weight: 700
    font-size: 24px
    line-height: 25px
    margin: 20px 0

    &-error
      font-size: 16px
      font-weight: 400
      color: #D2233C
      margin: 0 0 27px 0

  &-sum
    margin: 40px 0

  &-people
    display: flex
    width: calc(36px * 3)
    justify-content: space-between

    &-count
      border: 1px solid #E9E9E9
      padding: 8px
      font-size: 18px
      line-height: 19px
      width: 100%
      text-align: center
      font-weight: 400
      cursor: pointer
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out
      &:hover
        border-color: #80bdff

      &:nth-child(2)
        cursor: default
        &:hover
          border: 1px solid #E9E9E9

      &-desc
        color: #D2233C
        font-size: 16px
        font-weight: 400
        line-height: 17px
        margin: 20px 0

  &-item
    display: flex
    flex-direction: row
    font-size: 18px
    line-height: 19px
    font-weight: 400
    margin: 20px 0

    &-desc
      margin: 40px 0
      font-size: 24px
      line-height: 19px

    &-required
      color: #D2233C

    &-title
      background-color: #FAFAFA
      color: #000000
      font-size: 18px
      font-weight: 400
      line-height: 19px
      width: 100%
      padding: 13px

.date
  width: 262px

.row
  margin: 0
.visit__detail
  &-footer-description
    padding: 20px
    margin: 40px 0
    background: #F7F7F9

    &-title
      color: #D2233C
      font-size: 14px
      font-weight: 400
      line-height: 14.74px

    &-text
      font-weight: 400
      font-size: 12px
      line-height: 12.64px
      padding-top: 12px
  &-description
    color: #4A4A5A
    font-size: 16px
    line-height: 17px
    margin: 20px 0

    &-text
      font-size: 18px
      font-weight: 400
      line-height: 19px
      color: #000000
      margin: 20px 0
      max-width: 511px
      width: 100%

    &-ul
      margin: 20px -20px

      &-item
        font-size: 18px
        font-weight: 400
        line-height: 19px
        color: #000
        margin: 12px 0

    &-list
      display: flex
      flex-direction: row
      align-items: center

      &-title
        margin: 20px 0 0 0
        font-weight: 700
        color: #D2233C
        font-size: 18px
        line-height: 19px

      &-text
        padding: 12px 30px
        color: #000
        font-weight: 400
        font-size: 18px
        line-height: 19px

.visit__button
  display: block
  text-align: left
  &-btn
    min-width: 275px
    text-align: center
    display: inline-block
    background: #d2233c
    border-radius: 4px
    color: #fff !important
    text-transform: uppercase
    font: 700 16px/24px Futuris
    margin-top: 20px
    padding: 10px
    text-decoration: none
    cursor: pointer
    &.disabled
      background-color: #777
      border-color: #777
      cursor: not-allowed

  .consent-checkbox-label
    margin: 16px 0 0 0

.visit__detail-table
  color: #000000
  background-color: #EFEFEF
  max-width: 544px
  width: 100%
  display: flex
  padding: 8px 12px 8px 8px
  border: 1px solid #fff

  &-item
    width: 50%
    padding: 0 5px

  &:nth-child(2)
    background: #F4F4F4
</style>
